import { useQuery } from 'react-query';
import * as storeOrdersService from '../services/storeOrdersService';

export const useGetStoreOrders = (dto: storeOrdersService.ListStoreOrdersDto, options = {}) => {
  return useQuery({
    queryKey: ['storeOrders', dto],
    queryFn: () => storeOrdersService.getStoreOrders(dto),
    ...options
  });
}
